// @flow
import { connect } from 'react-redux';
import type { State } from '../../../../types';
import { activeSectionSelector } from '../../../../selectors/appSelectors';
import { permanentListSelector, temporaryListSelector, drawingSelector } from '../../../../selectors/zoneSelectors';
import Zones from '../Zones';
import type { Props } from '../Zones';

const mapStateToProps = (state: State) => {
    const drawing = drawingSelector(state);

    return {
        permanentList: permanentListSelector(state),
        temporaryList: temporaryListSelector(state),
        drawingEnabled: Boolean(drawing),
        drawingZoneId: drawing && drawing.zone && drawing.zone.id,
        showInactiveZones: activeSectionSelector(state) === 'zones'
    };
};

export default connect<Props, *, _, _, _, _>(mapStateToProps)(Zones);